function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.4679 11.9781L17.9812 7.50861L18.9014 6.58842C19.0329 6.45696 19.0329 6.23787 18.9014 6.0626L17.9374 5.09859C17.7621 4.96714 17.543 4.96714 17.4116 5.09859L12.0219 10.5321L6.58842 5.09859C6.45696 4.96714 6.23787 4.96714 6.0626 5.09859L5.09859 6.0626C4.96714 6.23787 4.96714 6.45696 5.09859 6.58842L10.5321 11.9781L5.09859 17.4116C4.96714 17.543 4.96714 17.7621 5.09859 17.9374L6.0626 18.9014C6.23787 19.0329 6.45696 19.0329 6.58842 18.9014L12.0219 13.4679L16.4914 17.9812L17.4116 18.9014C17.543 19.0329 17.7621 19.0329 17.9374 18.9014L18.9014 17.9374C19.0329 17.7621 19.0329 17.543 18.9014 17.4116L13.4679 11.9781Z",
  fill: "#A1A4B1"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.f98d4d2c.svg";
export { ForwardRef as ReactComponent };